import { useState } from 'react';

import { Spinner } from '../../primitives/Spinner';
import { fieldStyle } from '../venueCreateFields';

const MAX_BODY = 4000;

interface NoteTextFormProps {
  initial: string;
  /** Accessible name for the text box. */
  label: string;
  placeholder?: string;
  submitLabel: string;
  busy: boolean;
  onSubmit: (body: string) => void;
  onCancel: () => void;
  autoFocus?: boolean;
}

/** A text box with Cancel and a submit button, used to write or edit a note. */
export function NoteTextForm({
  initial,
  label,
  placeholder,
  submitLabel,
  busy,
  onSubmit,
  onCancel,
  autoFocus,
}: NoteTextFormProps) {
  const [body, setBody] = useState(initial);
  const trimmed = body.trim();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <textarea
        aria-label={label}
        value={body}
        rows={2}
        maxLength={MAX_BODY}
        placeholder={placeholder}
        autoFocus={autoFocus}
        onChange={(e) => setBody(e.target.value)}
        style={fieldStyle(undefined, {
          height: 'auto',
          padding: '8px 10px',
          resize: 'vertical',
          lineHeight: 1.5,
        })}
      />
      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          onClick={onCancel}
          disabled={busy}
          style={{ height: 26, fontSize: 11 }}
        >
          Cancel
        </button>
        <button
          type="button"
          className="nb-btn nb-btn-primary"
          disabled={busy || trimmed === '' || trimmed === initial.trim()}
          onClick={() => onSubmit(trimmed)}
          style={{ height: 26, fontSize: 11 }}
        >
          {busy && <Spinner size={10} color="currentColor" />}
          {busy ? 'Saving…' : submitLabel}
        </button>
      </div>
    </div>
  );
}
